import { Block } from "@components/Block/Block";
import { CMSBlock } from "@jwm/types/CMSBlock";
import { CMSSectionProps } from "@jwm/types/CMSSectionProps";
import React, { Fragment } from "react";

interface FragmentBlockProps {
    fragment: CMSBlock["fragment"];
    placement?: string;
    textColor?: string;
    refColor?: string;
    visitedLinkColor?: string;
    locale?: string;
    sectionBackground?: string;
    sectionIndex?: number;
    siteSpecialty?: {
        type: string;
        title: string;
    };
    sectionContent?: CMSSectionProps;
}

export const FragmentBlock = ({
    fragment,
    placement,
    textColor,
    refColor,
    visitedLinkColor,
    locale,
    sectionBackground,
    sectionIndex,
    siteSpecialty,
    sectionContent,
}: FragmentBlockProps): JSX.Element => {
    return (
        <Fragment>
            {fragment?.fragment?.length &&
                fragment?.fragment[0]?.content?.map((block: CMSBlock, i: number) => {
                    return (
                        <Block
                            textColor={textColor}
                            refColor={refColor}
                            visitedLinkColor={visitedLinkColor}
                            key={i}
                            content={block}
                            locale={locale}
                            placement={`${placement}:tmpFragment`}
                            sectionBackground={sectionBackground}
                            sectionIndex={sectionIndex}
                            siteSpecialty={siteSpecialty}
                            sectionContent={sectionContent}
                        />
                    );
                })}
        </Fragment>
    );
};
